module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_link.af654a5c.svg";